// @flow

import { RECEIVED_COMPARE_SETTINGS } from './constants';
import type { ReceivedCompareSettings } from './actions';

const initialState = {
  enabled: process.env.LISTO_FLAG_PDB_CTA_COMPARE === 'true',
  add_comparison_text: '',
  remove_comparison_text: '',
  car_add_button_text: '',
  max_items_in_comparison: 3,
  assortment_page_link: '',
  compare_page_link: '',
  car_selected: '',
  cars_selected: '',
  button_compare_cars: '',
  button_compare_car: '',
  compare_heading: '',
  tech_specs_heading: '',
  button_tech_specs: '',
  button_scroll_to_top: '',
  button_order: '',
  button_model_info: '',
  button_inspect_packages: '',
  row_heading_model: '',
  row_heading_baseprice: '',
  row_heading_baseprice_description: '',
  row_heading_type: '',
  row_heading_type_description: '',
  row_heading_color: '',
  row_heading_delivery_time: '',
  row_heading_duration: '',
  row_heading_kmpack: '',
  row_heading_claim_free: '',
  row_heading_price_difference: '',
  row_heading_price_per_km: '',
  row_heading_price: '',
  row_heading_motorization: '',
  row_heading_fuel: '',
  row_heading_power: '',
  row_heading_consumption: '',
  row_heading_transmission: '',
  row_heading_nr_of_doors: '',
  row_heading_weight: '',
  compare_popup_template_blacklist: ([]: Array<string> | string),
};

export type State = typeof initialState;

export default (state: State = initialState, action: ReceivedCompareSettings): State => {
  switch (action.type) {
    case RECEIVED_COMPARE_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
